import React from 'react';
import { Banner } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

const BagErrorBanner = () => {
  const [state, dispatch] = useProductDetailsPageContext();

  return (
    <Banner
      variant="error-border"
      onClose={() =>
        dispatch({
          type: 'SET_SHOPPING_BAG_ERROR',
          payload: {
            bagError: {},
          },
        })
      }
      headline={state?.bagError?.bagErrorTitle}
      data-testing-id="bag-error-message"
    >
      {state?.bagError?.bagErrorMessage}
    </Banner>
  );
};

export default BagErrorBanner;
